import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader } from 'lucide-react';
import { api } from '../services/api';
import Footer from '../components/Footer';

export default function StaticPage({ forcedSlug }) {
  const { slug: routeSlug } = useParams();
  const slug = forcedSlug || routeSlug;
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    const loadPage = async () => {
      try {
        setLoading(true);

        const [pageData, restaurantData] = await Promise.all([
          api.getStaticPage(slug),
          api.getRestaurant()
        ]);

        setPage(pageData);
        setRestaurant(restaurantData);

      } catch (err) {
        console.error('Failed to load page:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    loadPage();
  }, [slug]);

 useEffect(() => {
  if (page?.title && restaurant?.name) {
    document.title = `${page.title} - ${restaurant.name}`;
  } else if (page?.title) {
    document.title = page.title;
  } else {
    document.title = 'Page';
  }
}, [page, restaurant]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader className="w-8 h-8 text-amber-600 animate-spin" />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center p-8">
          <p className="text-gray-500 mb-4">Page not found</p>
          <button onClick={() => navigate('/')} className="text-amber-600 hover:underline">
            Go back to menu
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="text-sm font-medium">Back to Menu</span>
          </button>
          <h1 className="text-3xl font-bold text-gray-900">{page.title}</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
          <div 
            className="prose prose-gray max-w-none"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </div>
      </div>

      <Footer restaurant={restaurant} />
    </div>
  );
}
